<template>
  <div id="content" class="startup_page">
      <div class="content_div stats">
        <div class="row" >
            <div class="row">
              <!-- <div class="col-12 col-lg-6">
                <div class="vselect_container" >
                  <div class="zone_input">
                    <div class="zone_input_header">
                      <span class="zone_input_name">Filter by search field</span>
                    </div>

                  <v-autocomplete v-model="filtre.search_fields" :items="search_fields_for_user" item-title="search_field_name" item-value="search_field_id" chips closable-chips multiple ></v-autocomplete>
                    </div>
                </div>
              </div> -->

              <div class="col-12 col-lg-6">
                <div class="zone_input">
                  <div class="zone_input_header">
                    <span class="zone_input_name">Filter by date</span>
                  </div>
                <!-- <span></span> -->
                <div class="row">
                  <div class="col-12 dateSelectors">
                    <label for="from">
                      <VueDatePicker v-model="filtre.date[0]" :format="format" placeholder="FROM" :time="false" :max-date="Math.min(new Date(),filtre.date[1])" :enable-time-picker="false" :auto-apply="true" prevent-min-max-navigation ignore-time-validation>
                        <template #input-icon>
                            <img class="input-slot-image"  :src="require('@/assets/datepicker.svg')"/>
                        </template>
                      </VueDatePicker>
                    </label>

                    <label for="to">
                      <VueDatePicker v-model="filtre.date[1]" :format="format" placeholder="TO" :min-date='filtre.date[0]' :max-date="new Date()" :enable-time-picker="false" :auto-apply="true" prevent-min-max-navigation ignore-time-validation>
                        <template #input-icon>
                            <img class="input-slot-image"  :src="require('@/assets/datepicker.svg')"/>
                        </template>
                      </VueDatePicker>
                    </label>
                  </div>

                </div>
                  </div>

              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center filterBtnDiv">
                <button type="button" @click="filtrer()" name="button" class="next_step_btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16.555" height="14.824" viewBox="0 0 16.555 14.824">
    <path id="Tracé_145" data-name="Tracé 145" d="M851,1614.683l6.923,7.01L866,1609" transform="translate(-850.289 -1608.463)" fill="none" stroke="#fff" stroke-width="2"/>
  </svg>

                  Apply the filter
                </button>
                <button type="button" @click="resetFilter()" name="button" class="prev_step_btn">Reset the filter</button>
              </div>

            </div>

        </div>
        <div class="row canvasFunnel" style="margin-top:50px;" ref="canvasFunnel"  v-if="hasData == true">
          <div class="col-12 col-lg-9 chartDiv">
            <div class="chartCo">
              <!-- <CanvasJSChart :options="options" :style="styleOptions"  @chart-ref="chartInstance"/> -->

              <apexchart
   type="bar"

   :options="chartOptions"
   :series="series"
   @dataPointSelection="clickit"
 ></apexchart>


              <div class="hidder" >

              </div>
            </div>

          </div>




        </div>
        <div class="row"  style="margin-top:50px" v-else>
          <div class="alert alert-warning text-center">
            Sorry your selection gives no results
          </div>
        </div>
        <div class="col-center"  style="margin-top:50px" v-if="hasData == true">
              <button type="button" @click="openCustomization()" name="button" class="prev_step_btn">Customize the chart</button>
              <button type="button" @click="globalExport()" name="button" class="next_step_btn">Export to png file</button>
        </div>
        <div class="" ref="customization" >


          <div class="row" style="padding:30px 10px;border:1px solid #CCC;margin-top:50px;" v-show="showCustomization">
              <h2 class="customH2">Customize the chart</h2>
            <div class="col-6">
              <!-- <label style="margin-top:10px;margin-bottom:10px;width:100%;">
                <span style="display:block;font-weight:700;">Chart title</span>
                <input v-model="chartTitle" @input="updateChartTitle" class="innopearl_input"/>
              </label> -->
              <div class="zone_input">
                <div class="zone_input_header">
                  <span class="zone_input_name">Chart title</span>
                </div>
                <input v-model="chartTitle" @input="updateChartTitle" class="innopearl_input"/>
              </div>
            </div>
            <div class="col-6">
              <!-- <label style="margin-top:10px;margin-bottom:10px;width:100%;">
                <span style="display:block;font-weight:700;">First segment title</span>
                <input v-model="segment1" @input="updateChartTitle" class="innopearl_input" />
              </label> -->
              <div class="zone_input">
                <div class="zone_input_header">
                  <span class="zone_input_name">First segment title</span>
                </div>
                <div class="customizer">
                  <input v-model="segment1" @input="updateChartTitle" class="innopearl_input"/>
                  <input class="colorize" type="color" v-model='customcolors[0]' @change="updateColors"/>
                </div>

              </div>
            </div>
            <div class="col-6">
              <!-- <label style="margin-top:10px;margin-bottom:10px;width:100%;">
                <span style="display:block;font-weight:700;">Second segment title</span>
                <input v-model="segment2" @input="updateChartTitle" class="innopearl_input" />
              </label> -->
              <div class="zone_input">
                <div class="zone_input_header">
                  <span class="zone_input_name">Second segment title</span>
                </div>
                <div class="customizer">
                  <input v-model="segment2" @input="updateChartTitle" class="innopearl_input"/>
                  <input class="colorize" type="color" v-model='customcolors[1]' @change="updateColors"/>
                </div>


              </div>
            </div>
            <div class="col-6">
              <!-- <label style="margin-top:10px;margin-bottom:10px;width:100%;">
                <span style="display:block;font-weight:700;">Third segment title</span>
                <input v-model="segment3" @input="updateChartTitle" class="innopearl_input"/>
              </label> -->
              <div class="zone_input">
                <div class="zone_input_header">
                  <span class="zone_input_name">Third segment title</span>
                </div>
                <div class="customizer">
                  <input v-model="segment3" @input="updateChartTitle" class="innopearl_input"/>
                  <input class="colorize" type="color" v-model='customcolors[2]' @change="updateColors"/>
                </div>

              </div>
            </div>
            <div class="col-6">
              <!-- <label style="margin-top:10px;margin-bottom:10px;width:100%;">
                <span style="display:block;font-weight:700;">Fourth segment title</span>
                <input v-model="segment4" @input="updateChartTitle" class="innopearl_input"/>
              </label> -->

              <div class="zone_input">
                <div class="zone_input_header">
                  <span class="zone_input_name">Fourth segment title</span>
                </div>
                <div class="customizer">
                  <input v-model="segment4" @input="updateChartTitle" class="innopearl_input"/>
                  <input class="colorize" type="color" v-model='customcolors[3]' @change="updateColors"/>
                </div>

              </div>
            </div>
            <div class="col-center">
                <button type="button" name="button" class="next_step_btn" @click="closeCustomization()">Validate</button>
            </div>
      </div>



          </div>
      </div>
  </div>
</template>
<script>
import api from '../tools/api';
import { debounce } from 'lodash';
// import router from '@/router'
 import { toast } from 'vue-sonner'
 import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import VueApexCharts from "vue3-apexcharts";
export default {
  components: {
    VueDatePicker,
    apexchart: VueApexCharts,
  },
  name: 'StartupsStatsSpace',
  data() {
    return {
      pageInfo: {
        mainTitle : "My dashboard ",
        subTitle : "Review your current funnel",
      },
      filtre: {
        // search_fields: [],
        date : [new Date("2024-01-01"), new Date()],
      },

      customcolors: [
             '#8984CC',
             '#B38B2F',
             '#3883C5',
             '#0D528D',
           ],
      //APEX VERSION
      chartOptions: {
        responsive: [
            {
              breakpoint: 1000,
              options: {
                chart: {
                  height:450
                },
                legend:{
                  position:"bottom",
                  floating:false,
                  fontSize:"15px",
                },
                dataLabels: {
                     style: {
                       fontSize: "20px",
                       fontWeight: "bold"
                     },
                     formatter: function (val, opt) {
                       console.log(opt);
                       return opt.config.series[0].data[opt.dataPointIndex].real
                     },
                   }
              }
            }
          ],
        chart: {
          toolbar:{
            show:false,
          },
          type: 'bar',
          id:"test",
          events: {
                click: function(event ) {
                  console.log(event);
                  // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
                }
              }
        },
        states: {
            hover: {
                filter: {
                    type: 'none',
                }
            },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 0,
            barHeight: '80%',
                distributed: true,
            isFunnel: true,
            rangeBarOverlap: false
          },
        },
        tooltip: {
          enabled: false,
          y: {
            formatter: function(val) {
                return val+" innovators"

            },
            title: {
              formatter: function () {
                return ""
              }
            },
          }
        },
        dataLabels: {
             enabled: true,
             formatter: function (val, opt) {
               console.log(opt);
               return opt.config.series[0].data[opt.dataPointIndex].real + " innovators"
             },
             dropShadow: {
               enabled: false,
             },
             style: {
               fontSize: "18px",
               fontWeight: "bold"
             }
           },
           title: {
        text: '',
        align: 'middle',
        style: {
          fontSize: '24px',
            lineHeight: '29px',
            color: '#3783c5',
          },
      },
      legend:{
        position:"left",
        floating:true,
        fontSize:"15px",
      },
      colors: [
             '#e8c87d',
             '#B38B2F',
             '#3883C5',
             '#0D528D',
           ],
      },
      series: [
        {
          data: [
            {
              x: "Long List",
              y: 138,
              real : 0
            },
            {
              x: "Selected for assessment",
              y: 99,
              real : 0
            },
            {
              x: "Medium interest",
              y: 75,
              real: 0,
            },
            {
              x: "High interest",
              y: 30,
                      real: 0,
            },

          ],
        },
      ],
      //END APEX VERSION


      hasData : true,
      chartTitle: "",
      segment1: "Long list",
      segment2 :"Selected for assessment",
      segment3: "Medium interest",
      segment4: "High interest",
      search_fields_for_user :[],
      chart: null,
      showCustomization: false,
      longList : 2000,
      options: {
        theme: "light2",
        animationEnabled: false,
        title: {
        text: "Titre"
        },
        data: [{
          type: "funnel",
          indexLabelTextAlign: "center",
          indexLabel: "{name} : {y} innovators",
          indexLabelPlacement: "outside",
          indexLabelFontSize: 20,
          explodeOnClick: false,
          neckHeight: '170px',
          neckWidth: '250px',
          valueRepresents: "area",
          click: this.onClick,

          dataPoints: [
            { y: 0, name: "Long list",color:'#e8c87d' },
            { y: 0, name: "Selected for assessment",color:'#B38B2F' },
            { y: 0, name: "Medium interest",color:'#3883C5' },
            { y: 0, name: "High interest",color:'#0D528D' },
          ]
        }]
      },
      styleOptions: {
         height: "600px",
        width: "100%"
      }


    }
  },
  methods:{
    format(date){
      var day = date.getDate().toString().padStart(2,"0");
 var month = (date.getMonth() + 1).toString().padStart(2,"0");
 var year = date.getFullYear();

 return `${day}/${month}/${year}`;
},
    clickit: function(event, chartContext, config) {
      console.log('click', event, chartContext, config);
      console.log(config.dataPointIndex);
      var filtre_to_apply = this.filtre;
      if(config.dataPointIndex== 0){
        //logn list
        filtre_to_apply.titre_page = this.series[0].data[0].x;
        filtre_to_apply.level = "longlist";
        const { href } = this.$router.resolve({
           name: 'List of innovators filtered',
         params: {filterstoapply : JSON.stringify(filtre_to_apply)}
         });

         // Open the URL in a new tab
         window.open(href, '_blank');
      }
      else if(config.dataPointIndex == 1){
        //select for assessment
        filtre_to_apply.titre_page = this.series[0].data[1].x;
        filtre_to_apply.level = "assessed";
        const { href } = this.$router.resolve({
           name: 'List of innovators filtered',
         params: {filterstoapply : JSON.stringify(filtre_to_apply)}
         });

         // Open the URL in a new tab
         window.open(href, '_blank');
      }
      else if(config.dataPointIndex == 2){
        //medium interest
        filtre_to_apply.titre_page = this.series[0].data[2].x;
        filtre_to_apply.level = "medium";
        const { href } = this.$router.resolve({
           name: 'List of innovators filtered',
         params: {filterstoapply : JSON.stringify(filtre_to_apply)}
         });

         // Open the URL in a new tab
         window.open(href, '_blank');
      //  router.push({ name: 'List of innovators filtered', params: {filterstoapply : JSON.stringify(filtre_to_apply)}});
      }
      else if(config.dataPointIndex == 3){
        filtre_to_apply.titre_page = this.series[0].data[3].x;
        filtre_to_apply.level = "high";
        const { href } = this.$router.resolve({
           name: 'List of innovators filtered',
         params: {filterstoapply : JSON.stringify(filtre_to_apply)}
         });

         // Open the URL in a new tab
         window.open(href, '_blank');
      }
    },
      onClick : function(e){
        console.log(e);
        var filtre_to_apply = this.filtre;
        if(e.dataPointIndex == 0){
          //logn list
          filtre_to_apply.titre_page = this.series[0].data[0].x;
          filtre_to_apply.level = "longlist";
          const { href } = this.$router.resolve({
             name: 'List of innovators filtered',
           params: {filterstoapply : JSON.stringify(filtre_to_apply)}
           });

           // Open the URL in a new tab
           window.open(href, '_blank');
        }
        else if(e.dataPointIndex == 1){
          //select for assessment
          filtre_to_apply.titre_page = this.series[0].data[1].x;
          filtre_to_apply.level = "assessed";
          const { href } = this.$router.resolve({
             name: 'List of innovators filtered',
           params: {filterstoapply : JSON.stringify(filtre_to_apply)}
           });

           // Open the URL in a new tab
           window.open(href, '_blank');
        }
        else if(e.dataPointIndex == 2){
          //medium interest
          filtre_to_apply.titre_page = this.series[0].data[2].x;
          filtre_to_apply.level = "medium";
          const { href } = this.$router.resolve({
             name: 'List of innovators filtered',
           params: {filterstoapply : JSON.stringify(filtre_to_apply)}
           });

           // Open the URL in a new tab
           window.open(href, '_blank');
        //  router.push({ name: 'List of innovators filtered', params: {filterstoapply : JSON.stringify(filtre_to_apply)}});
        }
        else if(e.dataPointIndex == 3){
          filtre_to_apply.titre_page = this.series[0].data[3].x;
          filtre_to_apply.level = "high";
          const { href } = this.$router.resolve({
             name: 'List of innovators filtered',
           params: {filterstoapply : JSON.stringify(filtre_to_apply)}
           });

           // Open the URL in a new tab
           window.open(href, '_blank');
        }
      },
      openCustomization(){
        this.showCustomization = true;
        this.$nextTick(() => {
          this.$refs.customization.scrollIntoView({ behavior: 'smooth' });
     });

      },
      updateColors(){
        this.chartOptions = {
        ...this.chartOptions,
        ...{
          colors:this.customcolors,
        },
      };
    },
      closeCustomization(){
        this.showCustomization = false;

          this.$refs.canvasFunnel.scrollIntoView({ behavior: 'smooth' });
      },
      chartInstance(chart) {
        this.chart = chart;
      },
      updateChartTitle :
        debounce(function() {
          // Your input handling logic here
          this.chartOptions.title.text = this.chartTitle;
          this.chartOptions = {
          ...this.chartOptions,
          ...{
            title: {
              text: this.chartTitle
            },
          },
        };
          this.series[0].data[0].x = this.segment1;
          this.series[0].data[1].x = this.segment2;
          this.series[0].data[2].x = this.segment3;
          this.series[0].data[3].x = this.segment4;
          ////this.chart.render();
        }, 500
      ),
      filtrer(){
        console.log(this.filtre);
        this.showCustomization = false;
        this.hasData= true;
           api.post(process.env.VUE_APP_API_URL+"/restrict/get_my_startup_funnel",
               {
                   filtres: this.filtre
               },
               {
                 headers: {
                     'Content-Type': 'application/json',
               }
             }).then( (r) => {
             console.log(r.data);
             if(r.data){
               this.series[0].data[0].real = r.data.in_longlist;
               this.series[0].data[1].real = r.data.in_assessment;
               this.series[0].data[2].real = r.data.medium_interest;
               this.series[0].data[3].real = r.data.high_interest;
              //  if(r.data.candidates_in_pools){
              //
              //   this.series[0].data[0].real = r.data.candidates_in_pools.nombre_candidat_dans_pool;
              //   this.series[0].data[1].real = r.data.assessment_stats.totalItems;
              //   this.series[0].data[2].real = r.data.assessment_stats.mediumInterestCount;
              //   this.series[0].data[3].real = r.data.assessment_stats.highInterestCount;
              //   this.hasData = true;
              // }
              // else{
              //    this.series[0].data[0].real = 0;
              //     if(r.data.assessment_stats.totalItems){
              //       this.series[0].data[1].real = r.data.assessment_stats.totalItems;
              //       this.series[0].data[2].real = r.data.assessment_stats.mediumInterestCount;
              //       this.series[0].data[3].real = r.data.assessment_stats.highInterestCount;
              //      this.hasData = true;
              //     }
              //     else{
              //       this.series[0].data[1].real = 0;
              //       this.series[0].data[2].real = 0;
              //        this.series[0].data[3].real = 0;
              //        this.hasData = false;
              //     }
              //
              // }
              //this.chart.render();
            }else{
              this.hasData = false;
            }



           });
      },

      resetFilter(){
        this.filtre ={
          search_fields: [],
          date : [null,null],
        };
        this.filtrer();
      },
      globalExport(){
        this.chartOptions = {
        ...this.chartOptions,
        ...{
          legend:{
            position:"bottom",
            floating:false,
            fontSize:"15px",
          },
        },
      };
    this.$nextTick(() => {
      setTimeout(() => {
          this.exportToPNG();
          this.chartOptions = {
          ...this.chartOptions,
          ...{
            legend:{
              position:"left",
              floating:true,
              fontSize:"15px",
            },
          },
        };
      }, 600)


  });
  },
      async exportToPNG() {
       // Check if the chart instance is available


          const chartInstance = window.Apex._chartInstances.find(chart => chart.id === "test");
          console.log(chartInstance);
          const base64 = await chartInstance.chart.dataURI({scale: 2});


        if (chartInstance) {
       //   // Get the canvas element from the chart
       //   const chartCanvas = this.chart.container.getElementsByTagName('canvas')[0];
       //
       //   // Convert the canvas to a data URL
    //
       //
       //   // Create a link element
          const link = document.createElement('a');
          link.href = base64.imgURI;
          link.download =this.options.title.text+'.png';
       //
         // Trigger a click event to start the download
         link.click();
         toast.success('Your chart has been downloaded !');
       } else {
         // Notify the user if the chart instance is not available
         toast.error('Chart instance not available.');
       }




     },
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
     console.log("fILTRE",this.filtre);
     api.post(process.env.VUE_APP_API_URL+"/restrict/get_my_startup_funnel",
         {
             filtres: this.filtre
         },
         {
           headers: {
               'Content-Type': 'application/json',
         }
       }).then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log(r.data);
       if(r.data){
         this.series[0].data[0].real = r.data.in_longlist;
         this.series[0].data[1].real = r.data.in_assessment;
         this.series[0].data[2].real = r.data.medium_interest;
         this.series[0].data[3].real = r.data.high_interest;

         this.hasData = true;
       }
       else{
         this.series[0].data[0].real = 0;
         this.series[0].data[1].real = 0;
         this.series[0].data[2].real = 0;
          this.series[0].data[3].real = 0;
          this.hasData = false;
       }
       //this.chart.render();
     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });
   api.get(process.env.VUE_APP_API_URL+"/restrict/stats_startups/list_sf").then( (r) => {
     // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
     // console.log();
     // var temp = _.merge(this.candidatespool, r.data)
     console.log(r.data);
     this.search_fields_for_user = r.data;
   }).catch( (e) => {
     console.log(e);
      toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
 });

  },


}
</script>
<style scoped>

.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.chartDiv{
  margin:auto;
}
.col-center{
  text-align: center;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
box-sizing: border-box;
margin-top:10px;
margin-bottom: 20px;
height: 40px;
padding: 5px;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}


.customH2{
    color: #3783C5;
    font-size:21px;
    text-transform:uppercase;
    margin-bottom:20px;
}
.v-field--variant-filled .v-field__overlay{
  background:#FFF !important;
}

.dateSelectors{
  display:flex;
  flex-direction:row;
  gap:20px;
}
.dateSelectors label{
  flex:1;
}
.next_step_btn svg{
  margin-right:15px;
}
.filterBtnDiv{
  margin-top:20px;
}
@media screen and (max-width:800px){
  .dateSelectors{
    display:flex;
    flex-direction:column;
    gap:20px;
  }
  .dateSelectors label{
    width:100%;
  }
}

.chartCo{
  position:relative;
  min-height:700px;
}
.chartCo .hidder{
  position:absolute;
  width:63px;
  height:14px;
  background:#FFF;
  bottom:0;
  right:0;
}
.customizer{
  display: flex;
}
.colorize{
  border: 1px solid #DDDDDD;
  border-radius: 2px;
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 20px;
  height: 40px;
  padding: 5px;
}
</style>
<style>
.dp__pointer{
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.dp__input_icon {
  cursor: pointer;
  position: absolute;
  top: 50%;

  left: 10px !important;
}
.input-slot-image{
  width:100% !important;
  height:100% !important;
  object-fit: contain;
  object-position: center;
  display: block;
}
.apexcharts-legend.apx-legend-position-left {
 flex-direction: column;
 bottom: 40px !important;
 top: auto !important;
}

</style>
